import Datepicker from 'components/commons/datepicker'
import CheckboxList from 'components/commons/checkbox-list'
import { ADVANCE_FILTER_OPTIONS } from 'configs/order/configOrder'
import Select from 'components/commons/select'
import ModalAdvanceFilter from 'components/commons/modal-advance-filter'
import { Button } from 'avo-ui'
import clsx from 'clsx'
import icFilterWhite from 'assets/images/ic-filter-white.svg'
import icFilter from 'assets/images/ic-filter.svg'

export const AdvanceFilterModal = ({
    show,
    onHide,
    onSearchList,
    onChangeFilter,
    filterValue,
    options,
    clearFilter,
    onOpenAdvanceFilter,
    getFilterCount,
    onSubmitFilter,
}) => {
    return (
        <>
            <div className={'w-fit relative'}>
                <Button
                    className={clsx(getFilterCount() > 0 && '!bg-blue-90 !text-white')}
                    title={'Filter'}
                    icon={getFilterCount() > 0 ? icFilterWhite : icFilter}
                    type={'outline'}
                    onClick={onOpenAdvanceFilter}
                />
                <div
                    className={`absolute -right-1 -top-3.5 py-1 px-2.5 text-white bg-blue-95 rounded-full ${getFilterCount() > 0 ? 'block' : 'hidden'}`}
                >
                    {getFilterCount()}
                </div>
            </div>
            <ModalAdvanceFilter
                className={'!w-[850px]'}
                classNameContent={'!max-h-[500px] overflow-auto'}
                show={show}
                onHide={onHide}
                title={'Filter'}
                onClear={clearFilter}
                onSubmit={onSubmitFilter}
            >
                <div className={'grid grid-cols-2 gap-12 p-8'}>
                    <div className={'space-y-6'}>
                        <div className={'flex flex-row items-center justify-between'}>
                            <div className={'space-y-2'}>
                                <p>Filter by order start date</p>
                                <Datepicker
                                    className={''}
                                    name={'start-date'}
                                    value={filterValue?.start_date}
                                    onChange={(value) => onChangeFilter({ name: 'start_date', value })}
                                    format='YYYY-MM-DD'
                                    isClearable
                                />
                            </div>
                            <div className={'mt-7 mx-2'}>-</div>
                            <div className={'space-y-2'}>
                                <p>Filter by order end date</p>
                                <Datepicker
                                    name={'end-date'}
                                    value={filterValue?.end_date}
                                    onChange={(value) => onChangeFilter({ name: 'end_date', value })}
                                    format='YYYY-MM-DD'
                                    isClearable
                                />
                            </div>
                        </div>
                        <div className={'space-y-2'}>
                            <p>Filter by product</p>
                            <Select
                                name={'product_ids'}
                                className={'flex-1'}
                                optionsClassName={'max-h-40'}
                                placeholder={'Pilih product'}
                                options={options?.product_ids}
                                value={filterValue?.product_ids}
                                searchable
                                isMultiple
                                onChange={onChangeFilter}
                                onSearch={(keyword) => onSearchList('product_ids', keyword)}
                            />
                        </div>
                        <div className={'space-y-2'}>
                            <p>Filter by voucher</p>
                            <Select
                                name={'voucher_ids'}
                                className={'flex-1'}
                                optionsClassName={'max-h-40'}
                                placeholder={'Pilih voucher'}
                                options={options?.voucher_ids}
                                value={filterValue?.voucher_ids}
                                searchable
                                isMultiple
                                onChange={onChangeFilter}
                                onSearch={(keyword) => onSearchList('voucher_ids', keyword)}
                            />
                        </div>
                        <div className={'space-y-2'}>
                            <p>Filter by status</p>
                            <CheckboxList
                                placeholder={'Search status'}
                                name={'status'}
                                options={ADVANCE_FILTER_OPTIONS.status}
                                values={filterValue?.status || []}
                                onChange={(value) => onChangeFilter({ name: 'status', value })}
                            />
                        </div>
                    </div>
                    <div className={'space-y-6'}>
                        <div className={'space-y-2'}>
                            <p>Filter by payment method</p>
                            <CheckboxList
                                placeholder={'Search payment method'}
                                name={'Payment Method'}
                                options={options?.payment_services}
                                values={filterValue?.payment_services || []}
                                onChange={(value) => onChangeFilter({ name: 'payment_services', value })}
                            />
                        </div>
                        <div className={'space-y-2'}>
                            <p>Filter by shipping method</p>
                            <CheckboxList
                                placeholder={'Search shipping method'}
                                name={'Shipping Method'}
                                options={options?.shipping_aliases}
                                values={filterValue?.shipping_aliases || []}
                                onChange={(value) => onChangeFilter({ name: 'shipping_aliases', value })}
                            />
                        </div>
                    </div>
                </div>
            </ModalAdvanceFilter>
        </>
    )
}
